import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { badgeActions } from './badge.actions';
import { of, switchMap } from 'rxjs';
import { BadgeService } from '../services/badge.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class BadgeEffects {
  private readonly actions$ = inject(Actions);
  private readonly badgeService = inject(BadgeService);

  public loadEarnedBadges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(badgeActions.loadEarnedBadges),
      switchMap(() =>
        this.badgeService.getEarnedBadges().pipe(
          map(badges => badgeActions.loadEarnedBadgesSuccess({ badges })),
          catchError(error => of(badgeActions.loadEarnedBadgesFailure({ error })))
        )
      )
    )
  );
}
